import React from 'react';

/**
 * Hook to responsively check if a media query matches
 * @param query A matchMedia query {@see https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia#}
 * @param options An optional object of options
 * @param options.initialValue The initial value to set if no value is provided
 * @returns A boolean indicating if the query matches
 */
export function useMediaQuery(query: string, options?: { initialValue?: boolean }) {
	const [value, setValue] = React.useState(options?.initialValue ?? false);

	function onChange(event: MediaQueryListEvent) {
		setValue(event.matches);
	}

	React.useEffect(() => {
		const result = matchMedia(query);
		result.addEventListener('change', onChange);
		setValue(result.matches);
		return () => result.removeEventListener('change', onChange);
	}, [query]);

	return value;
}
